// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".theme--light.v-text-field--solo-inverted.v-input--is-focused > .v-input__control > .v-input__slot textarea {\n  color: #ffffff;\n}", ""]);
// Exports
module.exports = exports;
